import { ChangeDetectorRef, Component, Input, Output, EventEmitter } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject, Subscription } from 'rxjs';
import { CreateReminderDialogService } from '../create-reminder-dialog.service';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { CreateReminderComponent } from '../create-reminder/create-reminder.component';
import { FormsModule } from '@angular/forms';
import { snackbarService } from '@one/web-components';
import { SnackbarService } from '../../../services/snackbar.service';

@Component({
  selector: 'dl-reminder-table',
   standalone: true,
    imports:[OneWebComponentsAngularModule,CreateReminderComponent,FormsModule],
  templateUrl: './reminder-table.component.html',
  styleUrl: './reminder-table.component.scss'
})
export class ReminderTableComponent {

  sortInfo: { column: string, direction: string }[] = [{ column: 'DateDelivered', direction: 'desc' }];
  @Input() public displayedColumns = [];
  @Input() public tableData = [];
  @Input() public addMoreReminder: Subject<any>;
  @Input() public isDialogMode: boolean = false;
  @Input() public notificationData: any;
  @Input() public onEditReminder: (data: any, originalRow: any) => void;
  @Input() public onDeleteReminder: (reminder: any) => void;
   public dataSource = this.tableData;
  public selection = [];
  public selectedRow: any;
  public editRowIndex: number;
  remainderrowval:any;
  public editVisible : boolean;
  private mappingSubscription?: Subscription;
  data: { feedbackDueDate: Date; reminderData: any; remindersData: any; isEdit: boolean; isDialogMode: boolean; notificationData: any; };
  public constructor(private snackBarNotification: SnackbarService,private changeDetectorRef: ChangeDetectorRef,private createReminderDialogService: CreateReminderDialogService,private _QnSbnDataService:QnSbnDataServiceService) {}

  public ngOnInit(): void {
      if (!this.isDialogMode) {
      this.createReminderDialogService.setRemindersDate([]);
      this.mappingSubscription = this._QnSbnDataService.mappingData$.subscribe(observer=>{ 
        if(!this._QnSbnDataService.isEmpty(observer['notificationReminders'])){
          this.updateTableData(observer['notificationReminders']['remindersData']);
        }
      });
    }

    this.updateTableData(this.tableData);
    
    this.sortInfo = [{ column: 'CreationDate', direction: 'desc' }];
    
    this.addMoreReminder.subscribe(data => {
      console.log("addMoreReminder - received data:", data);
      
      // Update tableData with proper mapping
      this.tableData = data.map(item => ({
        reminderDate: item.reminderDate || '',
        reminderSubject: item.templateDetails?.templateSubject || item.reminderSubject || '',
        reminderMessage: item.templateDetails?.templateBody || item.reminderMessage || '',
        reminderSendMode: item.reminderSendMode ?? '0',
        reminderActionIcons: true
      }));
      
      // Update dataSource to reflect in the table
      this.dataSource = [...this.tableData];
      console.log("addMoreReminder - updated dataSource:", this.dataSource);
      this.changeDetectorRef.detectChanges();
    });
    
    console.log("ngOnInit - initial datasource:", this.dataSource);
    
    // this.dataSource.sort = this.sort;
  }

   private updateTableData(data: any[]): void {
    this.tableData = Array.isArray(data) ? data : [];
    this.dataSource = [...this.tableData];
    if (!this.isDialogMode) {
      this.createReminderDialogService.setRemindersDate(this.tableData);
    }
    this.changeDetectorRef.detectChanges();
  }

  public editReminderTemplate(row: any, indx: number): void {
    if (!this.isReminderEditable(row)) {
       this.snackBarNotification.snackBarMessage('alarm', 'Cannot edit reminders that are scheduled for today or in the past')
      return;
    }

    this.remainderrowval = row;
    this.editRowIndex = indx;
    this.data = { 
      feedbackDueDate: this.createReminderDialogService.dueDateValue, 
      reminderData: row, 
      remindersData: this.dataSource,
      isEdit: true,
      isDialogMode: this.isDialogMode,
      notificationData: this.notificationData 
    };
    this.editVisible = true; 
  }

  public onDialogClose(event: any): void {
    this.editVisible = false; 
    
    if (!event || !event.data) {
      this.createReminderDialogService.setRemindersDate(this.dataSource);
      return;
    }
    
    if (this.isDialogMode && this.onEditReminder) {
      this.onEditReminder(event.data[0], this.remainderrowval);
    } else {
      const reminderTable = [...this.dataSource];
      const updatedReminder = { ...event.data[0] };
      if (this.remainderrowval.reminderId) {
        updatedReminder.reminderId = this.remainderrowval.reminderId;
      }
      reminderTable[this.editRowIndex] = updatedReminder;
      this.updateTableData(reminderTable);
      this.addProduct(this.dataSource);
      
      
      this.snackBarNotification.snackBarMessage('positive', 'Reminder updated successfully');
    }
  }
  
  

  public deleteReminderTemplate(elm: any, index: number): void {
    if (!this.isReminderRemovable(elm)) {
       this.snackBarNotification.snackBarMessage('alarm', 'Cannot delete reminders that are scheduled for today or in the past');
      return;
    }

     if (this.onDeleteReminder) {
      this.onDeleteReminder(elm);
      return;
    }

    const filtered = this.dataSource.filter(item => item !== elm);
    console.log("filter",filtered);
    
    this.updateTableData(filtered);
    this.addProduct(filtered);
    this.snackBarNotification.snackBarMessage('positive', 'Reminder deleted successfully');
  }

   public isReminderEditable(reminder: any): boolean {
    if (!reminder.reminderDate) return true;
    const reminderDate = new Date(reminder.reminderDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    reminderDate.setHours(0, 0, 0, 0);
    return reminderDate > today;
  }

  public isReminderRemovable(reminder: any): boolean {
    return this.isReminderEditable(reminder);
  }

  public onSendModeChange(value: Event, elm: any, index: number): void {
    this.dataSource[index].reminderSendMode = value;
  }
  public addProduct(tData) {    
    if (!this.isDialogMode) {
      this._QnSbnDataService.getMappedQnsbnData({
        "remindersData":tData     
      },"NotificationReminders"); 
    }
    // this.dataSource.data = []
 }
  ngOnDestroy(): void {
   if (!this.isDialogMode) {
     this.addProduct(this.dataSource);
   }
   this.mappingSubscription?.unsubscribe();
  }

  public OnSort(column: string, value: string): void {
    console.log("cc",column,'value',value);
    
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    this.tableData = this.applySorting(this.dataSource);
    console.log("tabledata",this.tableData);
    
    this.changeDetectorRef.detectChanges();
  }

  applySorting(data: any[]): any[] {
    const dataCopy = [...data];
    if (this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a[column] ?? '';
          const bValue = b[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }
}

